/**
 * This is variant of the BSD checksum function.
 * It is used as it easily limited to smaller bit size in our case 16 bits
 */
export function hashString(value) {
    let hash = 65_521;
    for (let i = 0; i < value.length; i++) {
        const code = value.charCodeAt(i);
        hash = ((hash >> 1) + ((hash & 1) << 15) + code) & 0xffff;
    }
    return hash;
}
